import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _LEFT_PANEL_FINISH_DE, _LEFT_PANEL_DEAL_STAT, _MARKET_SCAN_PAYMENT_, _MARKET_SCAN_FILTER_T, _GROSS_TYPE_VS_LABEL, _MARKUP_TYPE_VS_RESER, _PAYMENT_TYPE_DOWNPAY, _PAYMENT_TYPE_SELLING, _EMPTY_PROGRAM_RESIDU, _DEPOSIT_TYPE_VS_LABE, _DEPOSIT_TYPES_VS_BOO;

import _invert from 'lodash/invert';
import { MARKUP_TYPES } from 'tbase/constants/retail/markupTypes';
import { DEAL_STATUS } from './deal.constants';
import { INTERNAL_FEE_CODES } from '../../constants/retail/fee.constants';
export var FIRST_HEADER_HEIGHT = 60;
export var REBATE_ID = 'ID';
export var LONGEST_LEASE_TERM = 72;
export var LEFT_PANEL_ITEMS = {
  DESKING: 'DESKING',
  CREDIT: 'CREDIT',
  FINANCE_AND_INSURANCE: 'FINANCE_AND_INSURANCE',
  RECAP: 'RECAP',
  DOCUMENTS: 'DOCUMENTS',
  DELIVERY: 'DELIVERY',
  CASHIERING: 'CASHIERING',
  CONTRACTS: 'CONTRACTS',
  TRANSACTION_POSTING: 'TRANSACTION_POSTING',
  CONCEIRGE: 'CONCEIRGE'
};
export var FIRST_MONTH_WAIVER = 'First Month Waiver';
export var FIRST_MONTH_WAIVER_ID = 1234; // has to be a number

export var LEFT_PANEL_FINISH_DEAL_STATUS_MAP = (_LEFT_PANEL_FINISH_DE = {}, _defineProperty(_LEFT_PANEL_FINISH_DE, LEFT_PANEL_ITEMS.DESKING, DEAL_STATUS.QUOTE), _defineProperty(_LEFT_PANEL_FINISH_DE, LEFT_PANEL_ITEMS.FINANCE_AND_INSURANCE, DEAL_STATUS.FINANCE_AND_INSURANCE), _defineProperty(_LEFT_PANEL_FINISH_DE, LEFT_PANEL_ITEMS.RECAP, DEAL_STATUS.FINANCE_AND_INSURANCE), _defineProperty(_LEFT_PANEL_FINISH_DE, LEFT_PANEL_ITEMS.DOCUMENTS, DEAL_STATUS.DOCS_SIGNING), _defineProperty(_LEFT_PANEL_FINISH_DE, LEFT_PANEL_ITEMS.CASHIERING, DEAL_STATUS.DOCS_PRINTED), _defineProperty(_LEFT_PANEL_FINISH_DE, LEFT_PANEL_ITEMS.TRANSACTION_POSTING, DEAL_STATUS.PRE_CLOSED), _LEFT_PANEL_FINISH_DE);
export var LEFT_PANEL_DEAL_STATUS_MAP = (_LEFT_PANEL_DEAL_STAT = {}, _defineProperty(_LEFT_PANEL_DEAL_STAT, DEAL_STATUS.QUOTE, LEFT_PANEL_ITEMS.DESKING), _defineProperty(_LEFT_PANEL_DEAL_STAT, DEAL_STATUS.FINANCE_AND_INSURANCE, LEFT_PANEL_ITEMS.FINANCE_AND_INSURANCE), _defineProperty(_LEFT_PANEL_DEAL_STAT, DEAL_STATUS.CONFIRMED, LEFT_PANEL_ITEMS.FINANCE_AND_INSURANCE), _defineProperty(_LEFT_PANEL_DEAL_STAT, DEAL_STATUS.RECAP, LEFT_PANEL_ITEMS.RECAP), _defineProperty(_LEFT_PANEL_DEAL_STAT, DEAL_STATUS.DOCS_SIGNING, LEFT_PANEL_ITEMS.DOCUMENTS), _defineProperty(_LEFT_PANEL_DEAL_STAT, DEAL_STATUS.UNWIND, LEFT_PANEL_ITEMS.RECAP), _defineProperty(_LEFT_PANEL_DEAL_STAT, DEAL_STATUS.DOCS_PRINTED, LEFT_PANEL_ITEMS.CASHIERING), _defineProperty(_LEFT_PANEL_DEAL_STAT, DEAL_STATUS.BOOKED, LEFT_PANEL_ITEMS.CONTRACTS), _defineProperty(_LEFT_PANEL_DEAL_STAT, DEAL_STATUS.CLOSED_OR_SOLD, LEFT_PANEL_ITEMS.DESKING), _defineProperty(_LEFT_PANEL_DEAL_STAT, DEAL_STATUS.LOST, LEFT_PANEL_ITEMS.RECAP), _defineProperty(_LEFT_PANEL_DEAL_STAT, DEAL_STATUS.PREORDER, LEFT_PANEL_ITEMS.DESKING), _defineProperty(_LEFT_PANEL_DEAL_STAT, DEAL_STATUS.PRE_CLOSED, LEFT_PANEL_ITEMS.DESKING), _LEFT_PANEL_DEAL_STAT);
export var LOAN = 'LOAN';
export var LEASE = 'LEASE';
export var CASH = 'CASH';
export var ONE_TIME_LEASE = 'ONE_TIME_LEASE';
export var BALLOON = 'BALLOON';
export var PAYMENT_FREQUENCY = {
  MONTHLY: 'MONTHLY',
  WEEKLY: 'WEEKLY',
  BIWEEKLY: 'BIWEEKLY',
  ONE_TIME: 'ONE_TIME',
  YEARLY: 'YEARLY',
  SEMI_MONTHLY: 'SEMI_MONTHLY'
};
export var PAYMENT_FREQUENCY_DISPLAY = {
  MONTHLY: 'Mo',
  WEEKLY: 'Wk',
  BIWEEKLY: 'Bi',
  ONE_TIME: 'One Time',
  YEARLY: 'Yearly'
};
export var PAYMENT_FREQUENCY_MSCAN_MAP = {
  MONTHLY: 0,
  BIWEEKLY: 1,
  WEEKLY: 2,
  ONE_TIME: undefined,
  YEARLY: 3
};
export var PAYMENT_FREQUENCY_CALCTYPE_MSCAN_MAP = {
  BIWEEKLY: 1,
  WEEKLY: 1
};
export var PAYMENT_FREQUENCY_DISPLAY_MAP = {
  MONTHLY: __('Monthly'),
  WEEKLY: __('Weekly'),
  BIWEEKLY: __('Bi-Weekly'),
  ONE_TIME: __('One Time'),
  YEARLY: __('Yearly'),
  SEMI_MONTHLY: __('Semi-Monthly')
};
export var PAYMENT_FREQUENCY_SHORT_DISPLAY = {
  MONTHLY: '/mo',
  WEEKLY: '/wk',
  BIWEEKLY: '/bi',
  ONE_TIME: '',
  YEARLY: '/Yr',
  SEMI_MONTHLY: '/sm'
};
export var PAYMENT_TYPES = {
  LOAN: LOAN,
  LEASE: LEASE,
  CASH: CASH,
  ONE_TIME_LEASE: ONE_TIME_LEASE,
  BALLOON: BALLOON
};
export var PAYMENT_TYPES_DISPLAY_MAP = {
  LOAN: 'Loan',
  LEASE: 'Lease',
  CASH: 'Cash',
  ONE_TIME_LEASE: 'One Pay Lease',
  BALLOON: 'Balloon'
};
export var SCAN_MODE_PAYMENT_TYPE_MAP = {
  LOAN: 3,
  LEASE: 1,
  CASH: 4,
  ONE_TIME_LEASE: 2,
  BALLOON: 1
};
export var DEFAULT_PAYMENT_FREQUECY_PAYMENT_TYPE = {
  LOAN: PAYMENT_FREQUENCY.MONTHLY,
  LEASE: PAYMENT_FREQUENCY.MONTHLY,
  CASH: PAYMENT_FREQUENCY.ONE_TIME,
  ONE_TIME_LEASE: PAYMENT_FREQUENCY.ONE_TIME,
  BALLOON: PAYMENT_FREQUENCY.MONTHLY
};
export var PAYMENT_FREQUENCY_OPTIONS_PAYMENT_TYPE = {
  LOAN: [PAYMENT_FREQUENCY.YEARLY, PAYMENT_FREQUENCY.MONTHLY, PAYMENT_FREQUENCY.BIWEEKLY, PAYMENT_FREQUENCY.WEEKLY],
  LEASE: [PAYMENT_FREQUENCY.YEARLY, PAYMENT_FREQUENCY.MONTHLY],
  CASH: [PAYMENT_FREQUENCY.ONE_TIME],
  ONE_TIME_LEASE: [PAYMENT_FREQUENCY.ONE_TIME],
  BALLOON: [PAYMENT_FREQUENCY.YEARLY, PAYMENT_FREQUENCY.MONTHLY]
};
export var PAYMENT_FREQUENCY_OPTIONS_PAYMENT_TYPE_CALC_ENGINE = {
  LOAN: [PAYMENT_FREQUENCY.MONTHLY, PAYMENT_FREQUENCY.WEEKLY, PAYMENT_FREQUENCY.BIWEEKLY, PAYMENT_FREQUENCY.SEMI_MONTHLY],
  LEASE: [PAYMENT_FREQUENCY.MONTHLY, PAYMENT_FREQUENCY.WEEKLY, PAYMENT_FREQUENCY.BIWEEKLY, PAYMENT_FREQUENCY.SEMI_MONTHLY],
  CASH: [PAYMENT_FREQUENCY.ONE_TIME],
  ONE_TIME_LEASE: [PAYMENT_FREQUENCY.ONE_TIME],
  BALLOON: [PAYMENT_FREQUENCY.MONTHLY]
};
export var MARKET_SCAN_PAYMENT_TYPES = (_MARKET_SCAN_PAYMENT_ = {}, _defineProperty(_MARKET_SCAN_PAYMENT_, PAYMENT_TYPES.LOAN, 'Retail'), _defineProperty(_MARKET_SCAN_PAYMENT_, PAYMENT_TYPES.LEASE, 'Lease'), _defineProperty(_MARKET_SCAN_PAYMENT_, PAYMENT_TYPES.CASH, 'Cash'), _defineProperty(_MARKET_SCAN_PAYMENT_, PAYMENT_TYPES.ONE_TIME_LEASE, 'OnePayLease'), _defineProperty(_MARKET_SCAN_PAYMENT_, PAYMENT_TYPES.BALLOON, 'Balloon'), _MARKET_SCAN_PAYMENT_);
export var MARKET_SCAN_FILTER_TYPES = (_MARKET_SCAN_FILTER_T = {}, _defineProperty(_MARKET_SCAN_FILTER_T, PAYMENT_TYPES.LOAN, 'Retail'), _defineProperty(_MARKET_SCAN_FILTER_T, PAYMENT_TYPES.CASH, 'Retail'), _defineProperty(_MARKET_SCAN_FILTER_T, PAYMENT_TYPES.LEASE, 'Lease'), _defineProperty(_MARKET_SCAN_FILTER_T, PAYMENT_TYPES.ONE_TIME_LEASE, 'Lease'), _defineProperty(_MARKET_SCAN_FILTER_T, PAYMENT_TYPES.BALLOON, 'Lease'), _MARKET_SCAN_FILTER_T);
export var PAYMENT_TYPE_MARKET_SCAN_MAP = {
  Retail: PAYMENT_TYPES.LOAN,
  Lease: PAYMENT_TYPES.LEASE,
  Cash: PAYMENT_TYPES.CASH,
  OnePayLease: PAYMENT_TYPES.ONE_TIME_LEASE,
  Balloon: PAYMENT_TYPES.BALLOON
};
export var FEE_OVERRIDES = {
  ALLOW_USER_OVERRIDE: 'ALLOW_USER_OVERRIDE',
  EXCLUDE_TAX_CALCULATIONS: 'EXCLUDE_TAX_CALCULATIONS'
};
export var DESKING_DISPLAY_NAME_FIELD_TYPES = {
  LENDER: 'LENDER',
  APR_MONEYFACTOR: 'APR_MONEYFACTOR',
  RESIDUAL: 'RESIDUAL',
  YEARLY_MILES: 'YEARLY_MILES',
  REBATE: 'REBATE',
  DUEBILLS: 'DUEBILLS',
  FEES: 'FEES',
  FNIMENU: 'FNIMENU',
  DAYS_TO_FIRSTPAYMENT: 'DAYS_TO_FIRSTPAYMENT',
  SECURITY_DEPOSIT: 'SECURITY_DEPOSIT',
  PAYMENT_FREQUENCY: 'PAYMENT_FREQUENCY',
  FINANCE_ADJUSTED_CAPITAL_COST: 'FINANCE_ADJUSTED_CAPITAL_COST',
  LOAN_TO_VALUE_RATIO: 'LOAN_TO_VALUE_RATIO',
  TAXES: 'TAXES',
  DRIVE_OFF: 'DRIVE_OFF',
  OUT_OF_POCKET_CASH: 'OUT_OF_POCKET_CASH',
  FINANCE_CHARGE: 'FINANCE_CHARGE'
};
export var FNI_CATEGORIES = {
  WARRANTY: 'WARRANTY',
  GAP: 'GAP',
  INSURANCE: 'INSURANCE',
  SERVICE_CONTRACT: 'SERVICE_CONTRACT',
  MULTI_LEVEL_SERVICE_CONTRACT: 'MULTI_LEVEL_SERVICE_CONTRACT'
};
export var CATEGORIES_BASED_ON_DISCLOSURE_TYPE = {
  SERVICE_CONTRACT: FNI_CATEGORIES.SERVICE_CONTRACT,
  INSURANCE: FNI_CATEGORIES.INSURANCE,
  DEBT_CANCELLATION_AGGREEMENT: FNI_CATEGORIES.GAP
};
export var TABS_THAT_NEEDS_SUBHEADER = [LEFT_PANEL_ITEMS.DESKING, LEFT_PANEL_ITEMS.RECAP];
export var DUE_BILL_DATA_SOURCE = {
  PARTS: 'PARTS',
  SERVICES: 'SERVICES',
  SETUP: 'SETUP',
  VEHICLE_EQUIPMENTS: 'LENDER SPECIFIC RESIDUALIZED OPTIONS'
};
export var GROSS_TYPES = {
  FRONT: 'FRONT',
  BACK: 'BACK'
};
export var GROSS_TYPE_VS_LABEL = (_GROSS_TYPE_VS_LABEL = {}, _defineProperty(_GROSS_TYPE_VS_LABEL, GROSS_TYPES.FRONT, 'Front'), _defineProperty(_GROSS_TYPE_VS_LABEL, GROSS_TYPES.BACK, 'Back'), _GROSS_TYPE_VS_LABEL);
export var DUE_BILL_PROFIT_TYPES = [{
  label: 'Front',
  value: GROSS_TYPES.FRONT
}, {
  label: 'Back',
  value: GROSS_TYPES.BACK
}];
export var DEFAULT_MILEAGE_TYPE = 'mi';
export var GROSS_CATEGORY = {
  VEHCILE_SALE: 'VEHCILE_SALE',
  TRADE_IN: 'TRADE_IN',
  FRONT_COST_ADJUSTMENTS: 'FRONT_COST_ADJUSTMENTS',
  FRONT_DUE_BILLS_OR_ACCESSORIES: 'FRONT_DUE_BILLS_OR_ACCESSORIES',
  FRONT_CASH_DEFICIENCY: 'FRONT_CASH_DEFICIENCY',
  FRONT_DEALER_CASH: 'FRONT_DEALER_CASH',
  FINANCE_RESERVES: 'FINANCE_RESERVES',
  FNI_PRODUCTS: 'FNI_PRODUCTS',
  BACK_COST_ADJUSTMENTS: 'BACK_COST_ADJUSTMENTS',
  BACK_DUE_BILLS_OR_ACCESSORIES: 'BACK_DUE_BILLS_OR_ACCESSORIES',
  BANK_FEE_MARKUP: 'BANK_FEE_MARKUP',
  CAPPED_INCEPTION_FEE: 'CAPPED_INCEPTION_FEE',
  FRONT_FNI_PRODUCTS: 'FRONT_FNI_PRODUCTS',
  BACK_FNI_PRODUCTS: 'BACK_FNI_PRODUCTS',
  ACQUISITION_FEE_MARKUP: 'ACQUISITION_FEE_MARKUP'
};
export var ROW_IDS = {
  FEE_DESKING_ROW: 'feesDeskingRow',
  TAX_ROW: 'taxRow',
  LENDER_ROW: 'LENDER_ROW',
  APR_MONEYFACTOR_ROW: 'APR_MONEYFACTOR_ROW',
  RESIDUAL_ROW: 'RESIDUAL_ROW',
  YEARLY_MYEARLY_MILES_ROWILES: 'YEARLY_MILES_ROW',
  REBATE_ROW: 'REBATE_ROW',
  DUEBILLS_ROW: 'DUEBILLS_ROW',
  FNIMENU_ROW: 'FNIMENU_ROW',
  DAYS_TO_FIRSTPAYMENT_ROW: 'DAYS_TO_FIRSTPAYMENT_ROW',
  SECURITY_DEPOSIT_ROW: 'SECURITY_DEPOSIT_ROW',
  PAYMENT_FREQUENCY_ROW: 'PAYMENT_FREQUENCY_ROW',
  FINANCE_ADJUSTED_CAPITAL_COST_ROW: 'FINANCE_ADJUSTED_CAPITAL_COST_ROW',
  LOAN_TO_VALUE_RATIO_ROW: 'LOAN_TO_VALUE_RATIO_ROW',
  ADD_COLUMN: 'ADD_COLUMN'
};
export var DEFAULT_PAYMENT_TYPE_FILTER = '1000';
export var DEFAULT_REGION_ID = 0;
export var MARKUP_DIVISOR = 1000;
export var RATE_TYPE_FACTOR = 2400;
export var FEES_STATUS = {
  ACTIVE: 'ACTIVE'
};
export var MILEAGE_STATUS_OPTIONS = {
  ACTUAL: 'ACTUAL',
  NOT_ACTUAL: 'NOT_ACTUAL',
  EXCEEDS_MECH_LIMITS: 'EXCEEDS_MECH_LIMITS'
};
export var RESERVE_METHOD = {
  MARKUP_BASED: 0,
  FLAT_AMOUNT: 1,
  CAPCOST_BASED: 2
};
export var MARKUP_TYPE_VS_RESERVE_METHOD = (_MARKUP_TYPE_VS_RESER = {}, _defineProperty(_MARKUP_TYPE_VS_RESER, MARKUP_TYPES.MARKUP_BASED, RESERVE_METHOD.MARKUP_BASED), _defineProperty(_MARKUP_TYPE_VS_RESER, MARKUP_TYPES.FLAT_AMOUNT, RESERVE_METHOD.FLAT_AMOUNT), _defineProperty(_MARKUP_TYPE_VS_RESER, MARKUP_TYPES.CAPCOST_BASED, RESERVE_METHOD.CAPCOST_BASED), _MARKUP_TYPE_VS_RESER);
export var RESIDUAL_DISPLAY_TYPE = {
  PERCENTAGE: 'PERCENTAGE',
  AMOUNT: 'AMOUNT'
};
export var LEASE_CONTRACT_FEES = [INTERNAL_FEE_CODES.DISPOSITION_FEE, INTERNAL_FEE_CODES.LOAN_PROCESSING_FEE];
export var MS_FEES = [INTERNAL_FEE_CODES.BANK_OR_ACQUISITION_FEE, INTERNAL_FEE_CODES.REGISTRATION_CHARGES, INTERNAL_FEE_CODES.STATE_FEE, INTERNAL_FEE_CODES.TITLE_FEE, INTERNAL_FEE_CODES.WASTE_TIRE_FEE, INTERNAL_FEE_CODES.LICENSE_FEE, INTERNAL_FEE_CODES.LIEN_FEE, INTERNAL_FEE_CODES.STATE_EMISSION_EXEMPTION_FEE, INTERNAL_FEE_CODES.PLATE_TRANSFER_FEE, INTERNAL_FEE_CODES.PUBLIC_SAFETY_VEHICLE_FEE, INTERNAL_FEE_CODES.TRANSFER_TAX, INTERNAL_FEE_CODES.WHEELAGE_TAX, INTERNAL_FEE_CODES.EV_REGISTRATION, INTERNAL_FEE_CODES.ENVIRONMENT_PROTECT_FEE, INTERNAL_FEE_CODES.LENDERS_AND_MEMBERS_FEE];
export var MILEAGE_TYPES = {
  MILES: 'MILES',
  KM: 'KM'
};
export var KM_TO_MILES_CONVERTOR_FACTOR = 1.60934;
export var DOWN_PAYMENT_TYPES = {
  LOAN_DOWNPAYMENTS: 'dp_loan',
  LEASE_DOWNPAYMENTS: 'dp_lease'
};
export var PAYMENT_TYPE_DOWNPAYMENT_TYPE_MAPPING = (_PAYMENT_TYPE_DOWNPAY = {}, _defineProperty(_PAYMENT_TYPE_DOWNPAY, PAYMENT_TYPES.LOAN, DOWN_PAYMENT_TYPES.LOAN_DOWNPAYMENTS), _defineProperty(_PAYMENT_TYPE_DOWNPAY, PAYMENT_TYPES.CASH, DOWN_PAYMENT_TYPES.LOAN_DOWNPAYMENTS), _defineProperty(_PAYMENT_TYPE_DOWNPAY, PAYMENT_TYPES.LEASE, DOWN_PAYMENT_TYPES.LEASE_DOWNPAYMENTS), _defineProperty(_PAYMENT_TYPE_DOWNPAY, PAYMENT_TYPES.ONE_TIME_LEASE, DOWN_PAYMENT_TYPES.LEASE_DOWNPAYMENTS), _defineProperty(_PAYMENT_TYPE_DOWNPAY, PAYMENT_TYPES.BALLOON, DOWN_PAYMENT_TYPES.LEASE_DOWNPAYMENTS), _PAYMENT_TYPE_DOWNPAY);
export var PAYMENT_TYPE_SELLINGPRICE_MAPPING = (_PAYMENT_TYPE_SELLING = {}, _defineProperty(_PAYMENT_TYPE_SELLING, PAYMENT_TYPES.LOAN, 'sellingPrice'), _defineProperty(_PAYMENT_TYPE_SELLING, PAYMENT_TYPES.CASH, 'sellingPrice'), _defineProperty(_PAYMENT_TYPE_SELLING, PAYMENT_TYPES.LEASE, 'leaseSellingPrice'), _defineProperty(_PAYMENT_TYPE_SELLING, PAYMENT_TYPES.ONE_TIME_LEASE, 'leaseSellingPrice'), _defineProperty(_PAYMENT_TYPE_SELLING, PAYMENT_TYPES.BALLOON, 'leaseSellingPrice'), _PAYMENT_TYPE_SELLING);
export var SOURCES_OF_FEES = {
  MARKET_SCAN: 'MARKET_SCAN',
  SALES_SETUP: 'SALES_SETUP',
  MANUALLY_ADDED: 'MANUALLY_ADDED'
};
export var KEYS_FOR_PROVIDER = ['vehiclesInfo', 'customersInfo', 'bootstrapData', 'salesChainList', 'fieldsMapToId', 'viSettingsRes', 'deal', 'downPayments', 'deferredPayments', 'deskingpaymentDetails', 'fniMenu', 'feeUpdateInfos', 'fniAttributesCodes', 'fniProductsList', 'rebateFilters', 'isDealDirty', 'dealAcquiredInfo', 'glBalance', 'glAccountId', 'lenders', 'dealerZip', 'printersInfo', 'creditApplications', 'trimInfos', 'DeskingActions', 'CommonActions', 'LeadsActions', 'financeDocuments', 'scanDocuments', 'docsetData', 'dealJacket', 'packageDocuments', 'allDealForms', 'salesSetupInfo'];
export var ROLLED_DEALS = 'rolledDeals';
export var AUTO_ROLL = 'autoRoll';
export var RESIDUAL_VALUE_FOR_EMPTY_PROGRAM_INFO = {
  residualOverridden: false,
  residualDisplayType: RESIDUAL_DISPLAY_TYPE.PERCENTAGE
};
export var DOCUMENT_ASSET_TYPES = {
  DEAL_CONCIERGE_VEHICLE_WALKTHROUGH: 'SALES_VEHICLE_WALKTHROUGH',
  SALES_CONSUMER_DOCS: 'SALES_CONSUMER_DOCS'
};
export var ACTIVITY_ASSET_TYPES = {
  DEAL: 'DEAL'
};
export var KEYS_FOR_CUSTOMER_OWNED_VEHICLE = ['vin', 'year', 'make', 'model', 'vehicleId'];
export var ADJUSTMENT_TYPE = {
  RO: 'RO',
  PO: 'PO'
};
export var ECONTARCT_STATUS_TYPE = {
  SUCCESS: 'Success',
  FAILED: 'Failed'
};
export var NOTIFICATION_TYPE = {
  ECONTRACT_FORM_DETAILS_UPDATE: 'ECONTRACT_FORM_DETAILS_UPDATE',
  FORM_DOC_UPDATE: 'FORM_DOC_UPDATE',
  FORM_SHARED: 'FORM_SHARED',
  FORM_PACKAGE_SUBMIT: 'FORM_PACKAGE_SUBMIT',
  FORM_SIGN_STATUS_UPDATE: 'FORM_SIGN_STATUS_UPDATE',
  DRS_FORM_SIGN_STATUS_UPDATE: 'DRS_FORM_SIGN_STATUS_UPDATE',
  ONLINE_CAST_FOR_SIGNING: 'ONLINE_CAST_FOR_SIGNING'
};
export var NA = 'NA';
export var FIRST_PAYMENT_WAIVED_DEFAULT_VALUE = 'firstPaymentWaivedDefaultValue';
export var MANUALLY_UPDATED_API_KEY = 'manuallyUpdated';
export var TAX_AND_ZIP_CODE_DETAILS_VS_KEY = {
  RETAIL: 'retail',
  LEASE: 'lease'
};
export var PAYMENT_TYPE_VS_TAX_TYPE = {
  LOAN: TAX_AND_ZIP_CODE_DETAILS_VS_KEY.RETAIL,
  CASH: TAX_AND_ZIP_CODE_DETAILS_VS_KEY.RETAIL,
  BALLOON: TAX_AND_ZIP_CODE_DETAILS_VS_KEY.RETAIL,
  LEASE: TAX_AND_ZIP_CODE_DETAILS_VS_KEY.LEASE,
  ONE_TIME_LEASE: TAX_AND_ZIP_CODE_DETAILS_VS_KEY.LEASE
};
export var TAX_TYPE_VS_PAYMENT_TYPE = _invert(PAYMENT_TYPE_VS_TAX_TYPE);
export var EMPTY_PROGRAM_RESIDUAL_DISPLAY_TYPE_VS_PAYMENT_TYPE = (_EMPTY_PROGRAM_RESIDU = {}, _defineProperty(_EMPTY_PROGRAM_RESIDU, PAYMENT_TYPES.BALLOON, RESIDUAL_DISPLAY_TYPE.AMOUNT), _defineProperty(_EMPTY_PROGRAM_RESIDU, PAYMENT_TYPES.LEASE, RESIDUAL_DISPLAY_TYPE.PERCENTAGE), _defineProperty(_EMPTY_PROGRAM_RESIDU, PAYMENT_TYPES.ONE_TIME_LEASE, RESIDUAL_DISPLAY_TYPE.PERCENTAGE), _EMPTY_PROGRAM_RESIDU);
export var CERTIFIED_FLAGS_VS_INFO_TEXT = {
  OEM_CERTIFIED: __("CPO refers to certification of the vehicle in accordance with the OEM's specifications and requirements"),
  DEALER_CERTIFIED: __('Dealer Certified refers to certification of vehicles just by your dealership and not by the OEM')
};
export var DEFAULT_SECURITY_DEPOSIT_OPTION = [{
  label: 0,
  value: 0
}];
export var DEPOSIT_TYPES = {
  SPECIAL: 'SPECIAL',
  STANDARD: 'STANDARD'
};
export var DEPOSIT_TYPE_VS_LABEL = (_DEPOSIT_TYPE_VS_LABE = {}, _defineProperty(_DEPOSIT_TYPE_VS_LABE, DEPOSIT_TYPES.SPECIAL, __('Special')), _defineProperty(_DEPOSIT_TYPE_VS_LABE, DEPOSIT_TYPES.STANDARD, __('Standard')), _DEPOSIT_TYPE_VS_LABE);
export var DEPOSIT_TYPES_VS_BOOL = (_DEPOSIT_TYPES_VS_BOO = {}, _defineProperty(_DEPOSIT_TYPES_VS_BOO, DEPOSIT_TYPES.SPECIAL, true), _defineProperty(_DEPOSIT_TYPES_VS_BOO, DEPOSIT_TYPES.STANDARD, false), _DEPOSIT_TYPES_VS_BOO);